import { render, staticRenderFns } from "./company-dynamics.vue?vue&type=template&id=bac88cea&scoped=true&"
import script from "./company-dynamics.vue?vue&type=script&lang=js&"
export * from "./company-dynamics.vue?vue&type=script&lang=js&"
import style0 from "./company-dynamics.vue?vue&type=style&index=0&id=bac88cea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bac88cea",
  null
  
)

export default component.exports